export const QUESTION_SLOT_FALLBACK_CSS = `
[data-incase-slot="question"] .c-questionLayout {
  display: flex;
  flex-direction: column;
  gap: 0.75em;
  box-sizing: border-box;
  width: 100%;
  font: inherit;
  color: inherit;
  background: transparent;
}
[data-incase-slot="question"] .c-questionLayout__body,
[data-incase-slot="question"] .c-questionElement {
  display: flex;
  flex-direction: column;
  gap: 0.5em;
}
[data-incase-slot="question"] .c-questionTitle,
[data-incase-slot="question"] .c-button,
[data-incase-slot="question"] .c-button__content {
  font: inherit;
  color: inherit;
}
[data-incase-slot="question"] .c-button {
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: 1px solid currentColor;
  border-radius: 0.25em;
  padding: 0.5em 0.75em;
  text-align: left;
  box-sizing: border-box;
  width: 100%;
  cursor: pointer;
}
[data-incase-slot="question"] .c-button--align-left {
  justify-content: flex-start;
}
[data-incase-slot="question"] .c-button__leading {
  flex-shrink: 0;
}
[data-incase-slot="question"] .c-questionElement__answer {
  position: relative;
}
[data-incase-slot="question"] .c-questionElement__answer.is-selected .c-button {
  outline: 2px solid currentColor;
}
[data-incase-slot="question"] .c-questionElement__answer_comment {
  position: absolute;
  right: 0;
  top: 0;
  transform: translate(30%, -30%);
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(26px * var(--answer-comment-scale, 1));
  height: calc(26px * var(--answer-comment-scale, 1));
  font-size: calc(22px * var(--answer-comment-scale, 1));
  z-index: 10;
  pointer-events: auto;
  cursor: pointer;
  color: inherit;
}
[data-incase-slot="question"] .c-questionElement__answer_comment svg {
  color: inherit;
  fill: currentColor;
}
[data-incase-slot="question"] .c-button--color-info + .c-questionElement__answer_comment svg {
  color: #589ec5;
}
[data-incase-slot="question"] .c-button--color-success + .c-questionElement__answer_comment svg {
  color: #48c774;
}
[data-incase-slot="question"] .c-button--color-error + .c-questionElement__answer_comment svg {
  color: #da2c38;
}
[data-incase-slot="question"] .c-button--color-warning + .c-questionElement__answer_comment svg {
  color: #cc7722;
}
[data-incase-slot="question"] .c-questionElement__answer_comment::before {
  content: '';
  position: absolute;
  inset: calc(-10px * var(--answer-comment-scale, 1));
  cursor: pointer;
}
[data-incase-slot="question"] .c-questionElement:has(.has-comment-open) .c-questionElement__answer:not(.has-comment-open) {
  opacity: 0.2;
}
.c-questionElement__answer_dropdown {
  visibility: hidden;
  position: absolute;
  z-index: 10;
  overflow-y: auto;
  background: #f5f5f5;
  color: #333;
  border: 1px solid currentColor;
  border-radius: 0.3em;
  max-height: 0;
  padding: 0 0.6em;
  overflow-wrap: anywhere;
}
.c-questionElement__answer_dropdown.is-visible {
  visibility: visible;
  max-height: 20em;
  padding: 0.5em 0.6em;
}
`;

export function injectQuestionSlotFallback(doc: Document): void {
    if (
        !doc.head ||
        !doc.querySelector('[data-incase-slot="question"]') ||
        doc.head.querySelector('style[data-incase-fallback="question"]')
    ) {
        return;
    }

    const style = doc.createElement('style');
    style.setAttribute('data-incase-fallback', 'question');
    style.textContent = QUESTION_SLOT_FALLBACK_CSS;
    doc.head.insertBefore(style, doc.head.firstChild);
}
